/**
 * surface — rilevamento della SUPERFICIE d'uso del tool.
 *
 * 'lim'      = lavagna interattiva / grande schermo in aula (proiezione):
 *              scala tipografica grande, sidebar a scomparsa, niente UI di
 *              authoring (si proietta, non si compone).
 * 'personal' = PC / tablet / telefono (uso individuale): tutto il resto.
 *
 * Ordine di decisione:
 *  1. esplicito via URL `?surface=lim|personal` — è ciò che passa il
 *     launcher Aula del hub (e che usiamo per simulare da PC);
 *  2. euristica device: viewport molto grande + touch + niente hover
 *     (una lavagna touch proiettata; un monitor PC ha il mouse → hover).
 *
 * L'esito vive su `<html data-surface="lim">` (assente su personal: i CSS
 * restano puliti). Questo è lo STANDARD per i prossimi tool — il toggle
 * Testo/Mappa (data-display) è un'altra cosa: cambia la VISTA, non la scala.
 */

export type Surface = 'lim' | 'personal';

export function detectSurface(): Surface {
  const param = new URLSearchParams(window.location.search).get('surface');
  if (param === 'lim') return 'lim';
  if (param === 'personal' || param === 'desktop') return 'personal';

  const big = Math.min(window.screen.width, window.innerWidth) >= 1280;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const noHover = window.matchMedia('(hover: none)').matches;
  return big && coarse && noHover ? 'lim' : 'personal';
}

/** Applica l'esito su <html>. Da chiamare PRIMA del boot della shell. */
export function applySurface(): Surface {
  const s = detectSurface();
  if (s === 'lim') document.documentElement.dataset.surface = 'lim';
  else delete document.documentElement.dataset.surface;
  return s;
}

export function isLimSurface(): boolean {
  return document.documentElement.dataset.surface === 'lim';
}
